import { render } from "./ErrorTitle.vue?vue&type=template&id=4be0035a&scoped=true"
import script from "./ErrorTitle.vue?vue&type=script&lang=js"
export * from "./ErrorTitle.vue?vue&type=script&lang=js"

import "./ErrorTitle.vue?vue&type=style&index=0&id=4be0035a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src766051562/src/medoor-medical-records/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be0035a"]])

export default __exports__